import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { bemGenerator } from '@prisjakt/ui-base';
import { Checkbox, TextInput } from '@prisjakt/ui-inputs';
import serialize from 'form-serialize';
import { AppContext } from '@prisjakt/ui-app-context';
import queryString from 'querystring';

import SubmitButton from '../components/submit-button';

import './index.scss';

const styles = bemGenerator('forgot-password', ['spacer', 'feedback']);

class RecoverSetNewPassword extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    const { password = '' } = serialize(e.target, { hash: true });
    const { key: hash, user: username } = queryString.decode(
      this.props.location.search.substr(1)
    );

    this.props.validate({ password }, () => {
      this.props.setNewPassword(hash, username, password);
    });
  }

  render() {
    const { errors, pending } = this.props;
    const { t } = this.context;

    return (
      <div>
        <form method="post" onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="columns small-12 medium-6">
              <TextInput
                name="password"
                label={t('account', 'forgot-password.change-new-label')}
                type={this.state.showPassword ? 'text' : 'password'}
                warning={errors.password}
                helper={
                  errors.password ? t('errors', errors.password[0].code) : null
                }
              >
                <Checkbox
                  name="showPassword"
                  label={t('account', 'input.password-toggle')}
                  onChange={() => {
                    this.setState(prevState => ({
                      showPassword: !prevState.showPassword,
                    }));
                  }}
                  checked={this.state.showPassword}
                />
              </TextInput>
            </div>
          </div>

          <div
            className={`${styles.spacer} row ${styles.feedback.withModifier({
              error: errors.form,
            })}`}
          >
            <div className="columns small-12 medium-6">
              {errors.form && t('errors', errors.form[0].code)}
            </div>
          </div>

          <div className={`row ${styles.spacer}`}>
            <div className="columns small-12 medium-6">
              <SubmitButton
                loading={pending}
                text={t('account', 'forgot-password.update-button')}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const { func, string, bool, object, shape } = PropTypes;

RecoverSetNewPassword.propTypes = {
  pending: bool,
  errors: object, // eslint-disable-line react/forbid-prop-types
  validate: func.isRequired,
  setNewPassword: func.isRequired,
  location: shape({
    search: string.isRequired,
  }).isRequired,
};

RecoverSetNewPassword.defaultProps = {
  errors: {},
  pending: false,
};

RecoverSetNewPassword.contextType = AppContext;

export default withRouter(RecoverSetNewPassword);
